/* ============================================================
   NAUTEAS FINE TEA — THEME JAVASCRIPT
   ============================================================ */

'use strict';

/* ── HEADER SCROLL ─────────────────────────────────────── */
(function () {
  const header = document.querySelector('.site-header');
  if (!header) return;
  const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 20);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

/* ── MOBILE MENU ───────────────────────────────────────── */
(function () {
  const btn   = document.querySelector('.header-menu-btn');
  const nav   = document.querySelector('.mobile-nav');
  if (!btn || !nav) return;
  btn.addEventListener('click', () => {
    const open = nav.classList.toggle('open');
    btn.classList.toggle('open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  });
})();

/* ── SEARCH DRAWER ─────────────────────────────────────── */
(function () {
  const openBtns  = document.querySelectorAll('[data-search-open]');
  const drawer    = document.querySelector('.search-drawer');
  const closeBtn  = document.querySelector('.search-drawer__close');
  const input     = document.querySelector('.search-drawer__input');
  if (!drawer) return;
  openBtns.forEach(btn => btn.addEventListener('click', () => {
    drawer.classList.add('open');
    setTimeout(() => input && input.focus(), 300);
  }));
  if (closeBtn) closeBtn.addEventListener('click', () => drawer.classList.remove('open'));
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') drawer.classList.remove('open');
  });
})();

/* ── PRODUCT GALLERY ───────────────────────────────────── */
(function () {
  const mainImg  = document.querySelector('#galleryMainImg');
  const thumbs   = document.querySelectorAll('.gallery-thumb');
  if (!mainImg || !thumbs.length) return;

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const src = thumb.dataset.src;
      mainImg.style.opacity = '0';
      setTimeout(() => {
        mainImg.src = src;
        mainImg.style.opacity = '1';
      }, 220);
    });
  });
})();

/* ── QUANTITY SELECTOR ─────────────────────────────────── */
(function () {
  document.querySelectorAll('[data-qty-btn]').forEach(btn => {
    btn.addEventListener('click', () => {
      const wrap  = btn.closest('[data-qty-wrap]');
      const disp  = wrap.querySelector('[data-qty-display]');
      const input = wrap.querySelector('[data-qty-input]');
      let val = parseInt(disp ? disp.textContent : input.value, 10) || 1;
      val = Math.max(1, val + parseInt(btn.dataset.qtyBtn, 10));
      if (disp) disp.textContent = val;
      if (input) input.value = val;
      updateDeliveryNudge(val);
    });
  });

  function updateDeliveryNudge(qty) {
    const nudge = document.querySelector('.delivery-nudge');
    if (!nudge) return;
    const priceEl = document.querySelector('[data-product-price]');
    if (!priceEl) return;
    const price = parseFloat(priceEl.dataset.productPrice || 0);
    const threshold = parseFloat(nudge.dataset.threshold || 30);
    const subtotal = price * qty;
    const remaining = (threshold - subtotal).toFixed(2);
    if (subtotal >= threshold) {
      nudge.textContent = '🎉 Free UK delivery unlocked!';
    } else {
      nudge.textContent = `Add £${remaining} more for free UK delivery`;
    }
  }
})();

/* ── ADD TO CART (AJAX) ────────────────────────────────── */
(function () {
  const form = document.querySelector('[data-product-form]');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn    = form.querySelector('.atc-btn');
    const label  = btn.querySelector('span');
    const origText = label.textContent;

    btn.setAttribute('data-loading', '');
    label.textContent = 'Adding...';

    try {
      const formData = new FormData(form);
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        label.textContent = '✓ Added to Bag';
        // Update cart count
        const cartData = await fetch('/cart.js').then(r => r.json());
        document.querySelectorAll('.cart-count').forEach(el => {
          el.textContent = cartData.item_count;
        });
        setTimeout(() => {
          label.textContent = origText;
          btn.removeAttribute('data-loading');
        }, 2500);
      } else {
        throw new Error('Add to cart failed');
      }
    } catch (err) {
      label.textContent = 'Try again';
      setTimeout(() => {
        label.textContent = origText;
        btn.removeAttribute('data-loading');
      }, 2000);
    }
  });
})();

/* ── STICKY ATC ────────────────────────────────────────── */
(function () {
  const stickyBar     = document.querySelector('.sticky-atc');
  const purchaseArea  = document.querySelector('.purchase-area');
  if (!stickyBar || !purchaseArea || window.innerWidth > 1024) return;

  const observer = new IntersectionObserver(([entry]) => {
    stickyBar.classList.toggle('visible', !entry.isIntersecting);
  }, { threshold: 0 });

  observer.observe(purchaseArea);
})();

/* ── ACCORDION ─────────────────────────────────────────── */
(function () {
  document.querySelectorAll('.accordion__trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item   = trigger.closest('.accordion__item');
      const isOpen = item.classList.contains('open');
      // Close all
      document.querySelectorAll('.accordion__item.open').forEach(i => i.classList.remove('open'));
      // Open clicked if was closed
      if (!isOpen) item.classList.add('open');
    });
  });
})();

/* ── SCROLL REVEAL ─────────────────────────────────────── */
(function () {
  const els = document.querySelectorAll('.reveal');
  if (!els.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      // Stagger siblings
      const siblings = Array.from(entry.target.parentNode.children).filter(c => c.classList.contains('reveal'));
      const idx = siblings.indexOf(entry.target);
      entry.target.style.transitionDelay = `${idx * 0.08}s`;
      entry.target.classList.add('in-view');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  els.forEach(el => observer.observe(el));
})();

/* ── CART REMOVE ITEMS ─────────────────────────────────── */
(function () {
  document.querySelectorAll('[data-remove-item]').forEach(btn => {
    btn.addEventListener('click', async () => {
      const key = btn.dataset.removeItem;
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      window.location.reload();
    });
  });
})();

/* ── QUANTITY IN CART ──────────────────────────────────── */
(function () {
  document.querySelectorAll('[data-cart-qty-btn]').forEach(btn => {
    btn.addEventListener('click', async () => {
      const key  = btn.dataset.cartQtyBtn;
      const dir  = parseInt(btn.dataset.dir, 10);
      const item = btn.closest('[data-cart-item]');
      const qty  = parseInt(item.dataset.qty, 10) + dir;
      if (qty < 0) return;
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      window.location.reload();
    });
  });
})();

/* ── NEWSLETTER FORM ───────────────────────────────────── */
(function () {
  const form = document.querySelector('[data-newsletter-form]');
  if (!form) return;
  form.addEventListener('submit', (e) => {
    // Shopify handles this natively — just provide visual feedback
    const btn = form.querySelector('.newsletter__submit');
    if (btn) {
      btn.textContent = 'Subscribed ✓';
      btn.disabled = true;
    }
  });
})();

/* ── COLLECTION FILTERS ────────────────────────────────── */
(function () {
  document.querySelectorAll('.filter-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const tag = btn.dataset.filter;
      const cards = document.querySelectorAll('.product-card[data-tags]');
      cards.forEach(card => {
        if (!tag || tag === 'all') {
          card.style.display = '';
        } else {
          const tags = card.dataset.tags || '';
          card.style.display = tags.includes(tag) ? '' : 'none';
        }
      });
    });
  });
})();
